import React from 'react';
import './TrackingDetails.css';
import SuccessIconTick from "../../Common/Svg/SuccessIconTick";
import MidStepCircle from '../../Common/Svg/MidStepCircle';
import PendingCircle from '../../Common/Svg/PendingCircle';
import FailedCircle from '../../Common/Svg/FailedCircle';
import WarningCircle from '../../Common/Svg/WarningCircle';
import { isMobileView } from '../../../Utility/utility';

const TrackingDetails = (props) => {
  const trackingDetails = {
    orderNumber: props.salesOrderData.trackingNumber,
    latestStatus: props.salesOrderData.status,
    latestDate:  props.salesOrderData.updatedDate.split(" ")[0],
    latestTime: props.salesOrderData.updatedDate.split(" ")[1],
    dateCreated: props.salesOrderData.orderDate.split(" ")[0],
    timeCreated:  props.salesOrderData.orderDate.split(" ")[1],
  }

  const trackingObj = {
    "Checkpoint 1": [
      {
        checkpoint: "Checkpoint 1",
        upcomming: "Order created",
        status: "Pending",
        current: "Order created",
        description: "Your order is still in a quote status and has not yet been submitted for approval.",
        completed: "Order created",
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["If you have submitted all your required documents, you will soon receive your quotation for approval."],
        icon: <SuccessIconTick />
      }
    ],
    "Checkpoint 2": [
      {
        checkpoint: "Checkpoint 2",
        upcomming: "Order approval",
        status: "Awaiting Customer Approval",
        current: "Your order is awaiting your approval",
        description: "We sent you a link via email to electronically accept your quote.",
        completed: "You've approved your order",
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["Your quote has been sent to your email inbox. Please click on the link in the email to accept the quote within 30 days."],
        icon: <PendingCircle />
      },
      {
        checkpoint: "Checkpoint 2",
        upcomming: "Order approval",
        status: "Customer Approved",
        current: "You've approved your order",
        description: "Thanks for giving us the go-ahead to process your order.",
        completed: "You've approved your order",
        icon: <SuccessIconTick />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We're getting your order ready. Once your order status is successful, your fibre can be installed."]
      },
    ],
    "Checkpoint 3": [
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status",
        status: "Vetting Error",
        current: "Order in progress",
        completed: "Order successful",
        icon: <PendingCircle />,
        additionalInfo: [<>Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</>],
        headerAdditionalInfo: "Need help or got a question?"
      },
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status",
        status: "Vetting Referred",
        current: "Order in progress",
        description: "Your application is incomplete. You may need to submit additional documents.",
        completed: "Order successful",
        icon: <WarningCircle />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["To upload the additional documents, check your email for the link."]
      },
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status",
        status: "Vetting Approved",
        current: "Order successful",
        description: "Congratulations! Your fibre order has been successful.",
        completed: "Order successful",
        icon: <SuccessIconTick />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We will communicate your Fibre installation booking."]
      },
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status", 
        status: "Awaiting Approval",
        current: "Your order is approved",
        description: "Congrats! Your order will now be booked for installation.",
        completed: "Order successful",
        icon: <SuccessIconTick />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We will now book your order for installation.", "Your infrastructure provider will call to make installation arrangements.", "Your fibre services will be installed and activated."]
      },
    ],
    "Checkpoint 4": [
      {
        checkpoint: "Checkpoint 4",
        upcomming: "Installation booking",
        status: "Partially Booked",
        current: "Installation booking in progress",
        description: "We are in the process of finalising other items in your order.",
        completed: "Installation booked",
        icon: <PendingCircle />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We are currently booking your order for installation.",
        "Your infrastructure provider will call to make installation arrangements."]
      },
      {
        checkpoint: "Checkpoint 4",
        upcomming: "Installation booking",
        status: "Booked",
        current: "Installation booked",
        description: "Your order has been handed over to the infrastructure provider.",
        completed: "Installation booked",
        icon: <SuccessIconTick />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["Your fibre services will be installed and activated."]
      },
    ],
    "Checkpoint 5": [
      {
        checkpoint: "Checkpoint 5",
        upcomming: "Fibre installation",
        status: "Partially Open",
        current: "Waiting for installation",
        description: "Installation arrangements have been made.",
        completed: "Installation complete",
        icon: <PendingCircle />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We're in the process of finalising other items in your order before it can go out for delivery.",
        "Your fibre services will be installed and activated."]
      },
      {
        checkpoint: "Checkpoint 5",
        upcomming: "Fibre installation",
        status: "Open",
        current: "Waiting for installation",
        description: "Installation arrangements have been made.",
        completed: "Installation complete",
        icon: <PendingCircle />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We're in the process of finalising other items in your order before it can go out for delivery.",
        "Your fibre services will be installed and activated."]
      },
      {
        checkpoint: "Checkpoint 5",
        upcomming: "Fibre installation",
        status: "Partially Complete",
        current: "Waiting for installation",
        description: "Installation arrangements have been made.",
        completed: "Installation complete",
        icon: <PendingCircle />,
        headerAdditionalInfo: "What happens next?",
        additionalInfo: ["We're in the process of finalising other items in your order before it can go out for delivery.",
        "Your fibre services will be installed and activated."]
      },

    ],
    "Checkpoint 6": [
      {
        checkpoint: "Checkpoint 6",
        upcomming: "Fibre activation",
        status: "Complete",
        current: "Your Fibre has been activated",
        description: "Congratulations! Your Fibre service has been installed and activated.",
        completed: "Your Fibre has been activated",
        icon: <SuccessIconTick />,
        additionalInfo: [<>Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</>],
        headerAdditionalInfo: "Need help or got a question?",
      },
    ],
    "Checkpoint Cancellation": [
      {
        checkpoint: "Checkpoint Cancellation",
        upcomming: "Checkpoint Cancellation",
        status: "Deferred",
        current: "Your cancellation request is in progress",
        description: "Your cancellation request has been approved and will be processed on the specified date.",
        completed: "Cancelled",
        icon: <WarningCircle />,
        additionalInfo: [<>Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</>],
        headerAdditionalInfo: "Need help or got a question?",
      },
      {
        checkpoint: "Checkpoint Cancellation",
        upcomming: "Checkpoint Cancellation",
        status: "Cancelled",
        current: "Order cancelled",
        description: "Your cancellation request has been approved.",
        completed: "Cancelled",
        icon: <FailedCircle />,
        additionalInfo: [<>Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</>],
        headerAdditionalInfo: "Need help or got a question?",
      },
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status",
        status: "Vetting Expired",
        current: "Order expired",
        description: "Due to missing documents, your order could not be completed.",
        completed: "Order approved",
        icon: <FailedCircle />,
        headerAdditionalInfo: "What can I do?",
        additionalInfo: [<>Please visit <a target={ '_blank' } href={ 'https://www.vodacom.co.za/vodacom/fibre/sales/leads' }>www.vodacom.co.za</a> to create a new fibre order.</>]
      },
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status",
        status: "Vetting Declined",
        current: "Order unsuccessful",
        description: "We have reviewed your application and are unable to proceed with your order.",
        completed: "Order unsuccessful",
        icon: <FailedCircle />,
        orderCancelled: true,
        additionalInfo: [<>Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</>],
        headerAdditionalInfo: "Need help or got a question?",
      },
      {
        checkpoint: "Checkpoint 3",
        upcomming: "Order status",
        status: "Rejected",
        current: "Order unsuccessful",
        description: "Your application was declined based on a credit check.",
        completed: "Order approved",
        icon: <FailedCircle />,
        orderCancelled: true,
        additionalInfo: [<>Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</>],
        headerAdditionalInfo: "Need help or got a question?",
      },
    ]
  }
  
  const trackingQuoteObj = [
    {
      status: "In Progress",
      current: "Your quote is being processed",
      description: "Your quote is being  processed and will sent to your mailbox.",
      icon: <PendingCircle />
    },
    {
      status: "Order Placed",
      current: "Your order has been placed",
      description: "Thank you for placing your fibre order with Vodacom. Your order has been approved and your SO order number will be sent to your email box for your reference.",
      icon: <SuccessIconTick />
    },
    {
      status: "Revised",
      current: "Your quote has been revised",
      description: "Your quote has been submitted with changes at your request",
      icon: <PendingCircle />
    },
    {
      status: "Approved",
      current: "Your quote has been approved",
      description: "Thank you for placing your fibre order with Vodacom. Your SO order number will be sent to your email box for your reference.",
      icon: <SuccessIconTick />
    }
  ]

  let currentCheckpoint = null;
  let currentQuoteCheckpoint = null;
  let checkpointsDone = [];
  let checkpointsToCome = [];
  let checkpoints = ["Checkpoint 1", "Checkpoint 2", "Checkpoint 3", "Checkpoint 4", "Checkpoint 5", "Checkpoint 6", "Checkpoint Cancellation"];

  checkpoints.map(checkpoint => {
    trackingObj[checkpoint].map(item => {
      if (item.status == trackingDetails.latestStatus) {
        currentCheckpoint = item;
      }
    })
  })
  
  trackingQuoteObj.map(item => {
    if (item.status == trackingDetails.latestStatus) {
      currentQuoteCheckpoint = item;
    }
  })

  if (currentCheckpoint) {
    for (var i = 0; i < checkpoints.length; i++) {
      if (currentCheckpoint.checkpoint == "Checkpoint Cancellation") {
        checkpointsDone.push(trackingObj["Checkpoint 1"][trackingObj["Checkpoint 1"].length - 1])
        break;
      }
      else if (checkpoints[i] != currentCheckpoint.checkpoint) {
        checkpointsDone.push(trackingObj[checkpoints[i]][trackingObj[checkpoints[i]].length - 1])
      }
      else
        break;
    }


    if (!currentCheckpoint.orderCancelled) {
      for (var i = checkpoints.indexOf(currentCheckpoint.checkpoint) + 1; i < checkpoints.length; i++) {
        if (checkpoints[i] != "Checkpoint Cancellation") {
          checkpointsToCome.push(trackingObj[checkpoints[i]][trackingObj[checkpoints[i]].length - 1])
        }
      }
    }
  }
  

  return (
    <div className="tracking-details-main-wrapper">
      {
        currentCheckpoint ?
          <div className="tracking-details-order-wrapper">
            <div className="tracking-details-order-number" style={checkpointsDone.length <= 0  && isMobileView() ? { paddingBottom: "1.5em"} :  null}>
              Order #{trackingDetails.orderNumber}
            </div>
              <div className="tracking-details-checkpoints-wrapper">
              {
                checkpointsDone.map(item =>{
                  return(
                    isMobileView() ?
                      <>
                        <div className="tracking-details-order-placeholder">
                          {
                            item.checkpoint == "Checkpoint 1" ?
                              <>
                                <div className="tracking-details-order-details">
                                  <div className="tracking-details-order-checkpointmark">
                                      <SuccessIconTick></SuccessIconTick>
                                  </div>
                                  <div className="tracking-details-order-checkpointdatetime">
                                    <div className="tracking-details-order-checkpointdate">
                                      { trackingDetails.dateCreated }
                                    </div>
                                    <div className="tracking-details-order-checkpointtime">
                                      { trackingDetails.timeCreated }
                                    </div>
                                  </div>
                                </div>
                                <div className="tracking-details-order-details-border">
                                  <div className="tracking-details-order-checkpointdescription">
                                  {item.completed}
                                  </div>
                                </div>
                              </>
                            :
                              <>
                                <div className="tracking-details-order-details-nodate">
                                  <div className="tracking-details-order-details">
                                    <div className="tracking-details-order-checkpointmark">
                                      <SuccessIconTick></SuccessIconTick>
                                    </div>
                                    <div className="tracking-details-order-checkpointdescription-nodate">
                                      {item.completed}
                                    </div>
                                  </div>
                                  <div className="tracking-details-order-details-border"></div>
                                </div>
                              </>
                            }
                        </div>
                      </>
                    :
                      <>
                        <div className="tracking-details-order-details">
                          <div className="tracking-details-order-checkpointdatetime">
                          {
                            item.checkpoint == "Checkpoint 1" ?
                              <>
                                <div className="tracking-details-order-checkpointdate">
                                  { trackingDetails.dateCreated }
                                </div>
                                <div className="tracking-details-order-checkpointtime">
                                  { trackingDetails.timeCreated }
                                </div>
                              </>
                            :
                            null
                          }
                          </div>
                          <div className="tracking-details-order-checkpointmark">
                            <SuccessIconTick></SuccessIconTick>
                          </div>
                          <div className="tracking-details-order-checkpointdescription">
                            {item.completed}
                          </div>
                        </div>
                        <div className="tracking-details-order-details-separator"></div>
                      </>
                  )
                })
              }
              {
                isMobileView() ? 
                  <>
                    <div className="tracking-details-order-details-current">
                      <div className="tracking-details-order-placeholder">
                        {
                          trackingDetails.latestDate ?
                            <>
                              <div className="tracking-details-order-details">
                                <div className="tracking-details-order-checkpointmark">
                                  {currentCheckpoint.icon}
                                </div>
                                <div className="tracking-details-order-checkpointdatetime">
                                  <div className="tracking-details-order-checkpointdate">
                                    { trackingDetails.latestDate }
                                  </div>
                                  <div className="tracking-details-order-checkpointtime">
                                    { trackingDetails.latestTime }
                                  </div>
                                </div>
                              </div>
                              <div className={ checkpointsToCome.length > 0 ? "tracking-details-order-details-border" : "tracking-details-order-details-border-end"}>
                                <div className="tracking-details-order-checkpointdescription">
                                  {currentCheckpoint.current}
                                </div>
                                <div className="tracking-details-order-current-desc">
                                <div className={ checkpointsToCome.length > 0 ? "tracking-details-order-details-current-details" : "tracking-details-order-details-current-end"}>
                                  <div className="tracking-details-order-description">
                                    { currentCheckpoint.description }
                                  </div>
                                  <div className="tracking-details-order-needhelp-bar">
                                    <div className="tracking-details-order-needhelp-bar-heading">{currentCheckpoint.headerAdditionalInfo}</div>
                                      <br />
                                      <ul style={currentCheckpoint.additionalInfo.length > 1 ? {'list-style': "disc", "paddingLeft": "1em"} : {'list-style': "none", "paddingLeft": "0"}}>
                                        {
                                          currentCheckpoint.additionalInfo.length > 1 ?
                                            currentCheckpoint.additionalInfo.map(item => {
                                              return (
                                                <li className="tracking-details-order-needhelp-bar-options">{ item }</li>
                                                )
                                              })
                                              :
                                              <li className="tracking-details-order-needhelp-bar-options">{ currentCheckpoint.additionalInfo[0] }</li>
                                            }
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          :
                            <>
                            <div className="tracking-details-order-details">
                              <div className="tracking-details-order-checkpointmark">
                                  {currentCheckpoint.icon}
                                </div>
                                </div>
                                <div className="tracking-details-order-details-border">
                              <div className="tracking-details-order-checkpointdescription">
                                {currentCheckpoint.current}
                              </div>
                              </div>
                              </>
                          }
                        </div>
                    </div>
                  </>
              :
              <>
                <div className="tracking-details-order-details-current">
                  <div className="tracking-details-order-details">
                    <div className="tracking-details-order-checkpointdatetime">
                      <div className="tracking-details-order-checkpointdate">
                        { trackingDetails.latestDate }
                      </div>
                      <div className="tracking-details-order-checkpointtime">
                        { trackingDetails.latestTime }
                      </div>
                    </div>
                    <div className="tracking-details-order-checkpointmark">
                      {currentCheckpoint.icon}
                    </div>
                    <div className="tracking-details-order-current-desc">
                      <div className="tracking-details-order-checkpointdescription">
                        {currentCheckpoint.current}
                      </div>
                      <div className={ checkpointsToCome.length > 0 ? "tracking-details-order-details-current-details" : "tracking-details-order-details-current-end"}>
                        <div className="tracking-details-order-description">
                          { currentCheckpoint.description }
                        </div>
                        <div className="tracking-details-order-needhelp-bar">
                          <div className="tracking-details-order-needhelp-bar-heading">{currentCheckpoint.headerAdditionalInfo}</div>
                          <br />
                          <ul style={currentCheckpoint.additionalInfo.length > 1 ? {'list-style': "disc", "paddingLeft": "1em"} : {'list-style': "none", "paddingLeft": "0"}}>
                            {
                              currentCheckpoint.additionalInfo.length > 1 ?
                                currentCheckpoint.additionalInfo.map(item => {
                                  return (
                                    <li className="tracking-details-order-needhelp-bar-options">{ item }</li>
                                    )
                                  })
                              :
                                <li className="tracking-details-order-needhelp-bar-options">{ currentCheckpoint.additionalInfo[0] }</li>
                            }
                          </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </>
            }
              {
                checkpointsToCome.map((item, index) => {
                  return(
                    <>
                      {
                        isMobileView() ?
                          <div className="tracking-details-order-details-checkpoints-to-come">
                            <div className="tracking-details-order-details">
                              <div className="tracking-details-order-checkpointmark">
                                <MidStepCircle></MidStepCircle>
                              </div>
                              <div className="tracking-details-order-checkpointdescription-nodate">
                                {item.upcomming}
                              </div>
                            </div>
                            { 
                              index != (checkpointsToCome.length - 1) ?
                                <div className="tracking-details-order-details-separator"></div> 
                              :
                                null
                            }
                        </div>
                        :
                        <div>
                          <div className="tracking-details-order-details">
                            <div className="tracking-details-order-checkpointdatetime"></div>
                              <div className="tracking-details-order-checkpointmark">
                                <MidStepCircle></MidStepCircle>
                              </div>
                            <div className="tracking-details-order-checkpointdescription">
                              {item.upcomming}
                            </div>
                          </div>
                          { 
                              index != (checkpointsToCome.length - 1) ?
                                <div className="tracking-details-order-details-separator"></div> 
                              :
                                null
                          }                   
                        </div>
                      }
                    </>
                  )
                })
              }
              </div>
          </div>
          :
            currentQuoteCheckpoint && isMobileView() ?
              <>
                <div className="tracking-details-order-details-current">
                  <div className="tracking-details-order-placeholder">
                      <div className="tracking-details-order-details">
                        <div className="tracking-details-order-checkpointmark">
                          {currentQuoteCheckpoint.icon}
                        </div>
                        <div className="tracking-details-order-checkpointdatetime">
                          <div className="tracking-details-order-checkpointdate">
                            { trackingDetails.latestDate }
                          </div>
                          <div className="tracking-details-order-checkpointtime">
                            { trackingDetails.latestTime }
                          </div>
                        </div>
                      </div>
                      <div className={"tracking-details-order-details-border-end"}>
                        <div className="tracking-details-order-checkpointdescription">
                          {currentQuoteCheckpoint.current}
                        </div>
                        <div className="tracking-details-order-current-desc">
                        <div className={"tracking-details-order-details-current-end"}>
                          <div className="tracking-details-order-description">
                            { currentQuoteCheckpoint.description }
                          </div>
                          <div className="tracking-details-order-needhelp-bar">
                            <div className="tracking-details-order-needhelp-bar-heading">Need help or got a question?</div>
                            <br />
                            <ul>
                              <li style={{'list-style': "none"}} className="tracking-details-order-needhelp-bar-options">Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            :
            currentQuoteCheckpoint && !isMobileView() ?
              <div className="tracking-details-order-wrapper">
                <div className="tracking-details-order-number">
                  Order #{trackingDetails.orderNumber}
                </div>
                <div className="tracking-details-checkpoints-wrapper">
                  <div className="tracking-details-order-details-current">
                    <div className="tracking-details-order-details">
                      <div className="tracking-details-order-checkpointdatetime">
                        <div className="tracking-details-order-checkpointdate">
                          { trackingDetails.latestDate }
                        </div>
                        <div className="tracking-details-order-checkpointtime">
                          { trackingDetails.latestTime }
                        </div>
                      </div>
                      <div className="tracking-details-order-checkpointmark">
                        {currentQuoteCheckpoint.icon}
                      </div>
                      <div className="tracking-details-order-current-desc">
                        <div className="tracking-details-order-checkpointdescription">
                          {currentQuoteCheckpoint.current}
                        </div>
                        <div className={"tracking-details-order-details-current-end"}>
                          <div className="tracking-details-order-description">
                            { currentQuoteCheckpoint.description }
                          </div>
                          <div className="tracking-details-order-needhelp-bar">
                            <div className="tracking-details-order-needhelp-bar-heading">Need help or got a question?</div>
                            <br />
                            <ul>
                              <li style={{'list-style': "none"}} className="tracking-details-order-needhelp-bar-options">Contact Vodacom Fibre support on <strong>082 1904</strong>, FREE from a Vodacom number. For help while roaming abroad, dial <strong>+27 82 1904</strong>.</li>
                            </ul>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            :
              null
        }
      </div>

  )
}

export default TrackingDetails;